import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Home from './pages/Home';
import HomeSdrStyle from './pages/HomeSdrStyle';
import AngebotPage from './pages/AngebotPage';
import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import LandingPage from './pages/LandingPage';
import QuizPage from './pages/QuizPage';
import OnboardingPage from './pages/OnboardingPage';
import RecruitingPage from './pages/RecruitingPage';
import RecruitingQuizPage from './pages/RecruitingQuizPage';
import GoogleLandingPage from './pages/GoogleLandingPage';
import GoogleQuizPage from './pages/GoogleQuizPage';
import GoogleThankYouPage from './pages/GoogleThankYouPage';
import LoginPage from './pages/portal/LoginPage';
import AuthCallback from './pages/portal/AuthCallback';
import Dashboard from './pages/portal/Dashboard';
import SaasPage from './pages/portal/SaasPage';
import ProtectedRoute from './components/portal/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';

// MAINTENANCE MODE - set to false to disable
const MAINTENANCE_MODE = false;

function MaintenancePage() {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-6 text-center"
      style={{ background: 'linear-gradient(160deg, #061620 0%, #0a2a3e 50%, #061620 100%)' }}
    >
      <div className="max-w-md">
        <span className="text-white font-bold text-2xl tracking-[0.2em] block mb-10" style={{ fontFamily: "'Lato', sans-serif" }}>
          VALORYX
        </span>
        <div className="w-14 h-14 rounded-full bg-[#3FA7DB]/20 flex items-center justify-center mx-auto mb-8">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#3FA7DB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 6v6l4 2"/><circle cx="12" cy="12" r="10"/></svg>
        </div>
        <h1 className="text-2xl sm:text-3xl text-white leading-tight mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          Wartungsarbeiten
        </h1>
        <p className="text-base text-white/60 leading-relaxed" style={{ fontFamily: "'Lato', sans-serif" }}>
          Wir führen aktuell geplante Wartungsarbeiten durch und sind in Kürze wieder für Sie erreichbar.
        </p>
      </div>
    </div>
  );
}

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();

  if (MAINTENANCE_MODE) {
    return <MaintenancePage />;
  }

  // Check URL fragment for session_id from OAuth callback — must be synchronous (before render)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/quiz" element={<QuizPage />} />
        <Route path="/check" element={<QuizPage />} />
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/recruiting" element={<RecruitingPage />} />
        <Route path="/recruiting/check" element={<RecruitingQuizPage />} />
        <Route path="/google" element={<GoogleLandingPage />} />
        <Route path="/google/quiz" element={<GoogleQuizPage />} />
        <Route path="/google/analyse" element={<GoogleQuizPage />} />
        <Route path="/google/check" element={<GoogleQuizPage />} />
        <Route path="/google/start" element={<GoogleQuizPage />} />
        <Route path="/google/beratung" element={<GoogleQuizPage />} />
        <Route path="/google/danke" element={<GoogleThankYouPage />} />
        <Route path="/angebot" element={<AngebotPage />} />
        <Route path="/original" element={<Home />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/portal" element={<LoginPage />} />
        <Route path="/portal/dashboard" element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        } />
        <Route path="/portal/saas" element={
          <ProtectedRoute>
            <SaasPage />
          </ProtectedRoute>
        } />
      </Routes>
    </AuthProvider>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
